export type Jisx0402Code = Jisx0402District['id']
export type Jisx0402District = (typeof PREFECTURE_CODES)[number]

const serializeSorted = (value: Jisx0402Code[]): string =>
  // eslint-disable-next-line fp/no-mutating-methods
  [...value].sort().join()

export const jisx0402CodesEquals = (
  one: Jisx0402Code[],
  other: Jisx0402Code[]
): boolean => {
  if (one.length !== other.length) {
    return false
  }
  return serializeSorted(one) === serializeSorted(other)
}

export const findByCode = (code: Jisx0402Code): Maybe<Jisx0402District> =>
  PREFECTURE_CODE_MAP[code]

export const PREFECTURE_CODES = [
  { id: '010006', name: '北海道' },
  { id: '020001', name: '青森県' },
  { id: '030007', name: '岩手県' },
  { id: '040002', name: '宮城県' },
  { id: '050008', name: '秋田県' },
  { id: '060003', name: '山形県' },
  { id: '070009', name: '福島県' },
  { id: '080004', name: '茨城県' },
  { id: '090000', name: '栃木県' },
  { id: '100005', name: '群馬県' },
  { id: '110001', name: '埼玉県' },
  { id: '120006', name: '千葉県' },
  { id: '130001', name: '東京都' },
  { id: '140007', name: '神奈川県' },
  { id: '150002', name: '新潟県' },
  { id: '160008', name: '富山県' },
  { id: '170003', name: '石川県' },
  { id: '180009', name: '福井県' },
  { id: '190004', name: '山梨県' },
  { id: '200000', name: '長野県' },
  { id: '210005', name: '岐阜県' },
  { id: '220001', name: '静岡県' },
  { id: '230006', name: '愛知県' },
  { id: '240001', name: '三重県' },
  { id: '250007', name: '滋賀県' },
  { id: '260002', name: '京都府' },
  { id: '270008', name: '大阪府' },
  { id: '280003', name: '兵庫県' },
  { id: '290009', name: '奈良県' },
  { id: '300004', name: '和歌山県' },
  { id: '310000', name: '鳥取県' },
  { id: '320005', name: '島根県' },
  { id: '330001', name: '岡山県' },
  { id: '340006', name: '広島県' },
  { id: '350001', name: '山口県' },
  { id: '360007', name: '徳島県' },
  { id: '370002', name: '香川県' },
  { id: '380008', name: '愛媛県' },
  { id: '390003', name: '高知県' },
  { id: '400009', name: '福岡県' },
  { id: '410004', name: '佐賀県' },
  { id: '420000', name: '長崎県' },
  { id: '430005', name: '熊本県' },
  { id: '440001', name: '大分県' },
  { id: '450006', name: '宮崎県' },
  { id: '460001', name: '鹿児島県' },
  { id: '470007', name: '沖縄県' },
] as const

export const PREFECTURE_CODE_MAP: Record<Jisx0402Code, Jisx0402District> =
  PREFECTURE_CODES.reduce<Record<Jisx0402Code, Jisx0402District>>(
    (map, distinct) => ({ ...map, [distinct.id]: distinct }),
    {} as Record<Jisx0402Code, Jisx0402District>
  )
